import SettingNavbar from '@/components/ApplicationSetting/SettingNavbar'

export const NavbarSettingController = () => {
    return <SettingNavbar />
}
